/*
 * @Author: 孙照
 * @LastEditTime: 2023-04-24 16:44:51
 * @Description: 数据处理公共方法
 * @FilePath: \fuzhou\src\utils\index.js
 */
/* Echarts图表字体、间距自适应 */
const fitChartSize = (size, defalteWidth = 1920) => {
  const clientWidth = window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;
  if (!clientWidth) return size;
  const scale = (clientWidth / defalteWidth);
  return Number((size * scale).toFixed(3));
};

function getLocation (dx, dy) {
  const tanV = dx / dy;
  const directSign = Math.abs(tanV) < 1;
  const t = directSign ? tanV : 1 / tanV;

  const sign1 = t > 0 ? 1 : -1;
  const sign2 = dx > 0 ? 1 : -1;
  const sign = directSign ? sign1 * sign2 : sign2;

  const group1 = [0.5 - sign * t / 2, 0.5 + sign * t / 2];
  const group2 = sign > 0 ? [0, 1] : [1, 0];
  const group = [...group1, ...group2];
  const keys = directSign ? ['x', 'x2', 'y', 'y2'] : ['y', 'y2', 'x', 'x2'];
  const res = {};
  keys.forEach((k, idx) => {
    res[k] = group[idx];
  });
  return res;
}
function getUnitReg (strValue) {
  const patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im;
  const tempValue = strValue.match(patrn); // 匹配结果，可能为空，还需要进行判断
  return tempValue[0];
}
// 格式化字符串数字
function formatStringNumber (num) {
  return num < 10 ? `0${num}` : `${num}`;
}
// 大屏实时时间
function getTime (time = new Date(), format = 'year-month-date') {
  const formatUnit = getUnitReg(format);
  const formatArr = format.split(formatUnit);
  let timerString = '';
  const dateObj = new Date(time);
  const year = dateObj.getFullYear();// 年
  let month = dateObj.getMonth() + 1;// 月  (注意：月份+1)
  let date = dateObj.getDate();// 日
  const day = dateObj.getDay();
  const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const week = weeks[day];// 根据day值，获取星期数组中的星期数。
  let hours = dateObj.getHours();// 小时
  let minutes = dateObj.getMinutes();// 分钟
  let seconds = dateObj.getSeconds();// 秒
  // 字符串格式化
  month = formatStringNumber(month);
  date = formatStringNumber(date);
  hours = formatStringNumber(hours);
  minutes = formatStringNumber(minutes);
  seconds = formatStringNumber(seconds);

  const timeObj = {
    year, month, date, hours, minutes, seconds, week,
  };

  const formatStrArr = formatArr.map((v) => timeObj[v]);
  timerString = formatStrArr.join(formatUnit);
  return timerString;
}

/**
 * 线性渐变起止方向的计算方法
 *
 *
 * @param {*} startArc 开始角度
 * @param {*} endArc 结束角度
 * @returns 四个坐标 x,y,x2,y2
 */
function getCoordinates (startArc, endArc) {
  const posi = [
    Math.sin(startArc),
    -Math.cos(startArc),
    Math.sin(endArc),
    -Math.cos(endArc),
  ];
  const dx = posi[2] - posi[0];
  const dy = posi[3] - posi[1];

  return getLocation(dx, dy);
}
/**
 *
 * @param {需要格式化的值} text
 * @param {保留小数位数,默认2} fixed
 * @param {需要转换的目标单位} unit
 * @param {转换规则值 例： 10000 转 1w，此值即为10000} per
*/
function numberFormat (text, fixed, unit, per, defaultRV = 0) {
  if (!fixed && fixed !== 0) {
    fixed = 2;
  }
  let result = defaultRV.toFixed(fixed);
  if (text) {
    text = Number(text);
    const arr = text.toFixed(fixed).split('.');

    result = `${arr[0].replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')}${arr[1] ? `.${arr[1]}` : ''}`;

    // 如果需要转换单位，需要满足当前值 > 转换基准值
    if ((unit || unit === '') && per && text >= per) {
      result = `${(text / per).toFixed(fixed)}${unit}`;
    }
  }
  return result;
}

// 保留指定位数小数
function toDecimal (x, n = 2) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x * 10 ** n) / 10 ** n;
  return f;
}

// 取整
function toInteger (x) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(x);
  return f;
}

// 数组求和
function sum (arr) {
  return arr.reduce((a, b) => a + b, 0);
}

// js 自适应宽高
const designWidth = 1920;
const designHeight = 1080;

const px2vw = (_px, needUnit = false) => (needUnit ? `${(_px * 100) / designWidth}vw` : (_px * 100) / designWidth);

const px2vh = (_px, needUnit = false) => (needUnit ? `${(_px * 100) / designHeight}vw` : (_px * 100) / designHeight);

const resizeVw2Px = (vw) => {
  const { innerWidth } = window;
  return vw * (innerWidth / 100);
};

const resizeVh2px = (vh) => {
  const { innerHeight } = window;
  return vh * (innerHeight / 100);
};
// 获取数组最大值
function getMaxValue (arr) {
  const max = Math.max(...arr);
  // 这样处理是为了不让最大值刚好到坐标轴最顶部
  return Math.ceil(max / 9.5) * 10;
}
// 获取数组最小值
function getMinValue (arr) {
  const min = Math.min(...arr);
  // 这样处理是为了不让最大值刚好到坐标轴最底部
  // return Math.floor(min / 12) * 10;
  return Math.floor(min);
}

// 如果数字超过 10000 则转换为 ---W 字符串
function formatNumber (num, unit = 'W') {
  if (!num) return '0.00';
  if (num > 10000) {
    return `${(num / 1000).toFixed(0)}${unit}`;
  }
  return num.toFixed(0);
}

export {
  fitChartSize,
  getTime,
  numberFormat,
  toDecimal,
  toInteger,
  px2vw,
  px2vh,
  resizeVw2Px,
  resizeVh2px,
  sum,
  getMaxValue,
  getMinValue,
  formatNumber,
};
